<script>
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { useExamDataStore } from "@/stores/exam/exam-data-store";
import { useExamFetchStore } from "@/stores/exam/exam-fetch-store";
import VideoPlayer from "@/components/CustomComponent/shared/VidioPlayer";
import { useAuthStore } from "@/stores/auth-store";

export default {
  props: {
    submissionID: {
      type: Number, // kalau mau angka bisa pakai Number
      required: true,
    },
  },
  components: {
    BaseLoading,
    VideoPlayer,
  },
  data() {
    return {
      file: null,
      previewVideo: null,
    };
  },
  computed: {
    sharedStore() {
      return useSharedStore();
    },
    authStore() {
      return useAuthStore();
    },
    examFetchStore() {
      return useExamFetchStore();
    },
    examDataStore() {
      return useExamDataStore();
    },
    vidioUrl() {
      return this.examFetchStore.examSubmissionDetail?.examVideoPath;
    },
    examType() {
      return this.examFetchStore.examSubmissionDetail?.exam?.examType;
    },

    isPracticalOrBoth() {
      return this.examType === "Practical" || this.examType === "Both";
    },

    isPending() {
      return this.examFetchStore.examSubmissionDetail?.status === "Pending";
    },

    inputDisabled() {
      // disable jika bukan practical/both atau status bukan pending
      return !this.isPracticalOrBoth || !this.isPending;
    },
  },
  async mounted() {
    await this.examFetchStore.fetchExamSubmissionsDetail(this.submissionID);
    this.loadVidioExam();
  },
  methods: {
    loadVidioExam() {
      const videoPath = this.examFetchStore.examSubmissionDetail?.examVideoPath;
      if (videoPath) {
        // backend biasanya kasih relative path → bikin absolute
        this.previewVideo = this.authStore.Url + videoPath;
      } else {
        this.previewVideo = null;
      }
    },
    handleFileChange(event) {
      this.file = event.target.files[0];
      if (this.file) {
        this.previewVideo = URL.createObjectURL(this.file);
        // lalu simpan ke FormData untuk dikirim ke backend
      }
    },
    async handelVidioUpload() {
      if (!this.file) return;

      // Pastikan hanya video
      if (!this.file.type.startsWith("video/")) {
        this.sharedStore.showError("File yang diupload harus berupa video 🎥");
        return;
      }

      await this.examDataStore.uploadVidio(this.submissionID, this.file);
    },
  },
};
</script>

<template>
  {{ console.log(examFetchStore.examSubmissionDetail) }}
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">My Exam</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                My Exam
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <!-- profile box -->
      <student-header></student-header>
      <!-- profile box -->
      <div class="row">
        <!-- sidebar -->
        <student-sidebar></student-sidebar>
        <!-- sidebar -->
        <div class="col-lg-9 quiz-wizard">
          <fieldset id="first-field">
            <div
              class="page-title d-flex align-items-center justify-content-between"
            >
              <h5>My Exam</h5>
            </div>
            <div class="quiz-attempt-card border-0">
              <div class="quiz-attempt-body p-0">
                <div class="border p-3 mb-3 rounded-2">
                  <div class="bg-light border p-3 mb-3 rounded-2 flex-wrap">
                    <div class="row align-items-center">
                      <div class="col-md-8">
                        <div class="mb-2 mb-md-0">
                          <div class="d-flex align-items-center">
                            <div>
                              <h5 class="fs-18">
                                {{
                                  examFetchStore.examSubmissionDetail
                                    ?.course_title
                                }}
                              </h5>
                              <p class="d-inline-flex align-items-center mb-0">
                                Attempt:
                                <span class="text-dark ms-1">{{
                                  examFetchStore.examSubmissionDetail?.attempt
                                }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="text-md-end">
                          <span
                            v-if="
                              examFetchStore.examSubmissionDetail?.status ===
                              'Pending'
                            "
                            class="badge badge-sm fs-12 rounded-pill bg-warning"
                            >{{
                              examFetchStore.examSubmissionDetail?.status
                            }}</span
                          >
                          <span
                            v-else-if="
                              examFetchStore.examSubmissionDetail?.status ===
                              'Passed'
                            "
                            class="badge badge-sm fs-12 rounded-pill bg-success"
                            >{{
                              examFetchStore.examSubmissionDetail?.status
                            }}</span
                          >
                          <span
                            v-else-if="
                              examFetchStore.examSubmissionDetail?.status ===
                              'Failed'
                            "
                            class="badge badge-sm fs-12 rounded-pill bg-danger"
                            >{{
                              examFetchStore.examSubmissionDetail?.status
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xxl col-lg-4 col-md-6">
                      <div class="card bg-primary">
                        <div class="card-body">
                          <h6 class="fw-medium mb-1 text-white">
                            MultipleChoice Grade
                          </h6>
                          <h4 class="fw-bold text-white">
                            {{
                              examFetchStore.examSubmissionDetail
                                ?.multipleChoiceScore
                                ? Math.round(
                                    examFetchStore.examSubmissionDetail
                                      ?.multipleChoiceScore
                                  )
                                : 0
                            }}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div class="col-xxl col-lg-4 col-md-6">
                      <div class="card bg-primary">
                        <div class="card-body">
                          <h6 class="fw-medium mb-1 text-white">Essay Grade</h6>
                          <h4 class="fw-bold text-white">
                            {{
                              examFetchStore.examSubmissionDetail?.essayScore
                                ? Math.round(
                                    examFetchStore.examSubmissionDetail
                                      ?.essayScore
                                  )
                                : 0
                            }}
                          </h4>
                        </div>
                      </div>
                    </div>
                    <div class="col-xxl col-lg-4 col-md-6">
                      <div class="card bg-success">
                        <div class="card-body">
                          <h6 class="fw-medium mb-1 text-white">
                            Over All Grade
                          </h6>
                          <h4 class="fw-bold text-white">
                            {{
                              examFetchStore.examSubmissionDetail?.totalScore
                                ? Math.round(
                                    examFetchStore.examSubmissionDetail
                                      ?.totalScore
                                  )
                                : 0
                            }}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="mb-3">
                    <div class="d-flex align-items-center justify-content-between mb-1">
                      <span class="fw-semibold text-gray-9">Quiz Progress</span>
                      <span>Question 1 out of 5</span>
                    </div>
                    <div class="progress progress-xs flex-grow-1 mb-1">
                      <div
                        class="progress-bar bg-success rounded"
                        role="progressbar"
                        style="width: 20%"
                        aria-valuenow="20"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div> -->
                  <div class="mb-0">
                    <h6 class="mb-3">Upload your Practical video</h6>
                    <div class="form-group">
                      <label for="examVideo" class="form-label"
                        >Choose video file</label
                      >
                      <input
                        class="form-control"
                        type="file"
                        id="examVideo"
                        name="examVideo"
                        accept="video/*"
                        @change="handleFileChange"
                        :disabled="inputDisabled"
                      />
                      <VideoPlayer
                        class="py-3"
                        :src="previewVideo"
                        v-if="previewVideo"
                      />
                    </div>
                    <div class="text-end">
                      <button
                        class="btn btn-primary mt-2"
                        type="button"
                        @click="handelVidioUpload"
                        :disabled="inputDisabled || !file"
                      >
                        Upload Video
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <BaseLoading v-show="sharedStore.loading"></BaseLoading>
  <!-- Footer -->
  <!-- <footer-two></footer-two> -->
  <!-- /Footer -->
</template>
